import { Component, OnInit } from '@angular/core';
import { TurnSummaryService } from '../../services/turn-summary.service';
import { ShopService } from '../../../configuration/services/shop.service';
import { UserService } from '../../../common/services/user.service';
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-tpv-summary-report',
  templateUrl: './tpv-summary-report.component.html',
  styleUrls: ['./tpv-summary-report.component.css'],
  providers:[TurnSummaryService,ShopService,UserService]
})
export class TpvSummaryComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  turnSummaries:any = [];
  filters:any = {
    previous_difference:{contains: ""},
    current_difference:{contains: ""},
  };
  exportParams:any ={};
  showExportButton:boolean = true;
  from:any;
  until:any;
  shops: any = [];
  users: any = [];
  onlyWithOpenIssue:boolean = false;
  onlyWithCloseIssue:boolean = false;
  role:number = 3;

  constructor(private turnSummaryService:TurnSummaryService, private shopService:ShopService, private userService:UserService) { }

  ngOnInit() {
    this.getTurnSummaries();
    this.getShops();
    this.getUsers();
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getShops(){
    return new Promise((resolve, reject) => {
        this.shopService.query({})
        .subscribe((shops) => {
            this.shops = shops;
            this.shops.unshift({name:"Todas", id:null})
            resolve();
        });
    });
  }

  getUsers(){
    this.userService.query({})
        .subscribe((users) => {
            this.users = users;
            this.users.unshift({id:null, username:"Ninguno"});
        });
  }

  getTurnSummaries(){
    if (this.onlyWithOpenIssue){
        this.filters.previous_difference = {};
        this.filters.previous_difference["!"] = 0;
    } else {
        delete this.filters.previous_difference;
    }
    if (this.onlyWithCloseIssue){
        this.filters.current_difference = {};
        this.filters.current_difference["!"] = 0;
    }else{
        delete this.filters.current_difference;
    }
    if (this.filters && this.filters.createdBy == null){
        delete this.filters.createdBy;
    }
    if (this.filters && this.filters.shop_id == null){
        delete this.filters.shop_id;
    }
    let params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.from && moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date[">="] = moment(this.from, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.until && moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
      params.where.date = params.where.date? params.where.date:{};
      params.where.date["<="] = moment(this.until, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    this.exportParams = params;
    this.turnSummaryService.query(params)
               .subscribe((turnSummaries) => {
                  let countParams = {
                    where: _.cloneDeep(params.where),
                  };
                  this.turnSummaryService.count(countParams)
                  .subscribe((count) => {
                    this.totalItems = count.count;
                  });
                  this.turnSummaries = turnSummaries;
                  this.turnSummaries.open_amount = this.roundValue(this.turnSummaries.open_amount);
                  this.turnSummaries.previous_difference = this.roundValue(this.turnSummaries.previous_difference);
                  this.turnSummaries.close_amount = this.roundValue(this.turnSummaries.close_amount);
                  this.turnSummaries.current_difference = this.roundValue(this.turnSummaries.current_difference);
                });
    }

    roundValue(value){
        return Math.round(value * 100) / 100;
    }

    getTurnName(init_date, end_date){
        var turn = "";
        if (parseInt(moment(init_date).format("HH")) < 14){
            turn = "Mañana";
            if (parseInt(moment(end_date).format("HH")) > 16){
                turn = "Partido";
            }
        }else if (parseInt(moment(init_date).format("HH")) > 14){
            turn = "Tarde";
        }
        return turn;
    }


    exportTurnSummariesToExcel(){
      this.showExportButton = false;
      var options = {   
          fieldSeparator: ';',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          showTitle: false,
          useBom: false,   
          bookType:'xlsx' ,  
          cellStyles:true,
      };             
      let report = [
            {
                field1:"Fecha de apertura",
                field2:"Fecha de cierre",
                field3:"Tienda",
                field4:"Usuario",
                field5:"Turno",
                field6:"Efectivo después de conteo (Apertura)",
                field7:"Descuadre (Apertura)",
                field8:"Efectivo después de conteo (Cierre)",
                field9:"Descuadre (Cierre)"
            }
        ]
        delete this.exportParams.skip;
        delete this.exportParams.limit;
        let observablePurchasesRequest = [];
        let request = Math.ceil(this.totalItems / 100);
        for (let i=0; i<request;i++){
          this.exportParams.skip = ((i)*100),
          this.exportParams.limit = 100;
          observablePurchasesRequest.push(this.turnSummaryService.query(this.exportParams));
        }
        Observable.forkJoin(observablePurchasesRequest)
            .subscribe(data => {
              let p:any = data;
              let turnSummaries = p.flat(); 
              turnSummaries.forEach(turnSummary =>{
                  var row = {
                      field1:turnSummary.createdAt?moment(turnSummary.createdAt).format("DD-MM-YYYY"):"",
                      field2:turnSummary.updatedAt?moment(turnSummary.updatedAt).format("DD-MM-YYYY"):"",
                      field3:turnSummary.shop?turnSummary.shop.name:"",
                      field4:turnSummary.createdBy?turnSummary.createdBy.username:"",
                      field5:this.getTurnName(turnSummary.createdAt, turnSummary.updatedAt),
                      field6:turnSummary.open_amount?turnSummary.open_amount:"",
                      field7:turnSummary.previous_difference?turnSummary.previous_difference:"",
                      field8:turnSummary.close_amount?turnSummary.close_amount:"",
                      field9:turnSummary.current_difference?turnSummary.current_difference:""
                  }
                  report.push(row);
              });
                  var mystyle = {   
                      headers:true,       
                      columns:    
                          [{columnid:'field1',width:100,title: ''},   
                          {columnid:'field2',width:100,title: ''},
                          {columnid:'field3',width:100,title: 'LISTADO DE APERTURAS/CIERRES'},
                          {columnid:'field4',width:100,title: ''},
                          {columnid:'field5',width:100,title: ''},
                          {columnid:'field6',width:100,title: ''},
                          {columnid:'field7',width:100,title: ''},
                          {columnid:'field8',width:100,title: ''},
                          {columnid:'field9',width:100,title: ''}
                          
                          ],
                      /*header*/
                    
                      column: {  
                          style:{
                              Alignment:{
                                  Horizontal:"Center",
                                  Vertical:"Center",  
                                  WrapText:1
                                  
                              },
                              Font:{
                                  Bold:"1",
                                  Color:"#000000",
                                  Size:10
                              },
                              
                              Interior:{
                                  Color:"#7CEECE",
                                  Pattern:"Solid"
                              }
                          }},
                    cells: {    
                          0:{
                              0:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid",
                                          },
                                  Alignment:{
                                    Horizontal:"Center",
                                    Vertical:"Center",
                                    WrapText: 1,
                                      },  
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                                  },                        
                                  }  
                              },
                              1:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                              },  
                                  Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },            
                                      }
                              },
                              2:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                          }, 
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              }                
                                      }
                                  },
                              3:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1,
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                        
                                      }
                                  },
                              4:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                          },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                          },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  },
                              5:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                  },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                           
                                      }
                                  }, 
                              6:{style:{
                                  Interior:{ 
                                      Color:"#95a5a6",
                                      Pattern:"Solid"
                                              },
                                  Alignment:{
                                      Horizontal: 'Center', 
                                      Vertical: 'Center',
                                      WrapText: 1, 
                                  },
                                  Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },                             
                                  }
                                  }, 
                                  7:{style:{
                                      Interior:{ 
                                          Color:"#95a5a6",
                                          Pattern:"Solid"
                                                  },
                                      Alignment:{
                                          Horizontal: 'Center', 
                                          Vertical: 'Center',
                                          WrapText: 1, 
                                      },
                                      Font:{
                                          Size:10,
                                          Bold:"1",
                                          Color:"#000000",
                                  },                             
                                      }
                                      },
                                      8:{style:{
                                          Interior:{ 
                                              Color:"#95a5a6",
                                              Pattern:"Solid"
                                                      },
                                          Alignment:{
                                              Horizontal: 'Center', 
                                              Vertical: 'Center',
                                              WrapText: 1, 
                                          },
                                          Font:{
                                              Size:10,
                                              Bold:"1",
                                              Color:"#000000",
                                      },                             
                                          }
                                          },
                          }   
                    },
            };
            this.showExportButton = true;
            alasql.promise('SELECT * INTO XLSXML("Resumen_Aperturas_Cierres'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
            .then(function(data){
                console.log('Data saved');
            }).catch(function(err){
                console.log('Error:', err);
            });
          });
    }

}



// WEBPACK FOOTER //
// ./src/app/tpv/components/tpv-summary-report/tpv-summary-report.component.ts